import React, { PureComponent } from 'react';
import SelectPager from './select/SelectPager';
import { loadProjectsOptions } from '../../select/ProjectSelect';
import { getJiraProjectVersions } from '../../../services/jira-services';

class ProjectVersionSteps extends PureComponent {
    render() {
        const pages = [
            {
                title: 'Select project',
                key: 'select_project',
                searchPlaceHolder: 'Start typing to find more',
            },
            {
                title: 'Select project version',
                key: 'select_project_version',
                searchPlaceHolder: 'Start typing to find more',
                backButtonLabel: 'Search in different project',
            },
        ];

        return (
            <div>
                <SelectPager
                    placeholder="Select project versions"
                    pages={pages}
                    value={this.props.value}
                    onChange={this.props.onChange}
                    isOpen={this.props.isOpen}
                    onPageRequestItems={(pageKey, triggerItem, searchText, onReady) => {
                        // eslint-disable-next-line default-case
                        switch (pageKey) {
                            case 'select_project': {
                                loadProjectsOptions(searchText)
                                    .then(onReady)
                                    .catch(() => {
                                        onReady([]);
                                    });
                                break;
                            }
                            case 'select_project_version': {
                                getJiraProjectVersions({
                                    jiraProjectId: triggerItem.value,
                                    searchText,
                                    statuses: ['unreleased'],
                                    maxParallelRequests: 20,
                                })
                                    .then((res) => {
                                        onReady(
                                            (res ?? []).map((version) => {
                                                return {
                                                    label: version.name,
                                                    value: parseInt(version.id, 10),
                                                    triggerValue: triggerItem.value,
                                                    type: 'version',
                                                    released: version.released,
                                                    archived: version.archived,
                                                };
                                            }),
                                        );
                                    })
                                    .catch(() => {
                                        onReady([]);
                                    });
                                break;
                            }
                        }
                    }}
                />
            </div>
        );
    }
}
export default ProjectVersionSteps;
